import { render, staticRenderFns } from "./RemoteMonitoringTemplatesAdd.vue?vue&type=template&id=6bffcadd"
import script from "./RemoteMonitoringTemplatesAdd.vue?vue&type=script&lang=js"
export * from "./RemoteMonitoringTemplatesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports